


















































/* 共通 */
import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { masterEditionModule } from '../store/modules/MasterEdition'; // ストアモジュール
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ

import { KanriConstants } from '../fixed/KanriConstants';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.07.04 [2023F-02] add
 */
@Component
export default class MasterEditionInfo extends ApiAccessBase {
  // 参照モードかどうか
  private isReadMode: boolean = true;

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '申請受付期間登録';
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['master_edition_info']);
    let path = '';
    if (masterEditionModule.GET_IS_MASTER_EDITION_KEY_SETTING) {
      // 編集時
      path = KanriConstants.EDITION_PATH + masterEditionModule.GET_PATH;
    } else {
      // 新規登録時
      path = KanriConstants.EDITION_PATH + '/init/info';
    }
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          this.isReadMode = supervisingModule.IS_MODE_READ;
        }
      },
    );
  }

  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.IS_MODE_READ) {
      this.back();
    } else {
      if (window.confirm(Message.I0015)) {
        if (masterEditionModule.GET_IS_MASTER_EDITION_KEY_SETTING) {
          this.apiAccess(KanriConstants.EDITION_PATH + masterEditionModule.GET_EXCLUSIVE_DELETE_PATH, Constants.API_METHOD_POST, false, null)
          .then((result) => {
            if (result === Constants.API_RESULT_SUCCES) {
              this.back();
            }
          });
        } else {
          this.back();
        }
      }
    }
  }
  private back() {
    // キー情報削除
    masterEditionModule.moduleSelectReset();
    router.push({ name: 'masterEditionSearch' });
  }

  /**
   * 登録
   */
  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    // 確認
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.apiAccess(masterEditionModule.GET_REGIST_PATH, Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('masterEditionInfo', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        // キー情報を設定
        if (!masterEditionModule.GET_IS_MASTER_EDITION_KEY_SETTING) {
          const masterEditionKey = {traderType: this.formData.traderType, nendo: this.formData.nendo};
          masterEditionModule.setMasterEdition(masterEditionKey);
        }
      } else {
      }
    });
  }
}
